import React, { createContext, useContext, useState } from 'react';

// Presentatiemodus: verbergt bedragen (Offertes, Facturen, Financieel)
// Standaard ALTIJD verborgen; via het oogje tijdelijk zichtbaar (alleen huidige sessie)
const PrivacyContext = createContext({ privacy: true, togglePrivacy: () => {} });

export const PrivacyProvider = ({ children }) => {
  const [privacy, setPrivacy] = useState(() => sessionStorage.getItem('privacy_mode') !== '0');
  const togglePrivacy = () => setPrivacy(p => {
    sessionStorage.setItem('privacy_mode', p ? '0' : '1');
    return !p;
  });
  return (
    <PrivacyContext.Provider value={{ privacy, togglePrivacy }}>
      {children}
    </PrivacyContext.Provider>
  );
};

export const usePrivacy = () => useContext(PrivacyContext);
